import {CART, shopUtilities, WISHLIST} from "@global/shop-utilities/shop-utilities";

const globalMaterialTile = {
    init: (elementClass) => {
        const wishlistItems = document.querySelectorAll(`.${elementClass} .${shopUtilities.options.wishlist.class}`);
        wishlistItems.forEach(item => {
            shopUtilities.registerListeners(item, WISHLIST);
        });

        const cartItems = document.querySelectorAll(`.${elementClass} .${shopUtilities.options.cart.class}`);
        cartItems.forEach(item => {
            shopUtilities.registerListeners(item, CART);
        });
    }
};

export { globalMaterialTile }
